import React from "react";
import { Label, Segment } from "semantic-ui-react";

export const StatsBox = props => {
  return (
    <Segment>
      <Label color="red" ribbon>
        {props.label}
      </Label>
      <span
        style={{
          display: "block",
          fontSize: "1.8em",
          marginTop: "0.4em",
          textAlign: "center"
        }}
      >
        {props.value}
      </span>
    </Segment>
  );
};
